import {componentsHelper} from './_helper'

export default [
  {
    path: '/cart',
    ...componentsHelper('cart/index')
  }
]



// WEBPACK FOOTER //
// ./client/router/cart.js